import { ButtonProps, Icon, Tooltip } from "@chakra-ui/react";
import React from "react";
import { HiOutlinePlus } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

import { Button } from "../../../components";

type CreateAiInterviewerButtonProps = {
  buttonProps?: ButtonProps;
  disabledReason?: string;
};

export const CreateAiInterviewerButton: React.FC<
  CreateAiInterviewerButtonProps
> = ({ buttonProps, disabledReason }) => {
  const navigate = useNavigate();
  const button = (
    <Button
      leftIcon={<Icon as={HiOutlinePlus} boxSize="5" />}
      size="sm"
      flexShrink={0}
      bg="#4D37DE"
      color="white"
      borderRadius="6px"
      _hover={{ bg: "#3D2BBE" }}
      _active={{ bg: "#2D1F9E" }}
      {...buttonProps}
      onClick={() => {
        navigate("/ai-interviewer/new");
      }}
      isDisabled={!!disabledReason}
    >
      New AI interviewer
    </Button>
  );

  return disabledReason ? (
    <Tooltip label={disabledReason} hasArrow shouldWrapChildren>
      {button}
    </Tooltip>
  ) : (
    button
  );
};
